import {ApplicationConfig} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import {provideNoopAnimations} from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { provideI18n } from '../../../shared/i18n/provide-i18n';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideNoopAnimations(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideI18n(),
  ],
};
